import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ApiAsyncPipe, ApiErrorComponent, StatusNoticeComponent } from '@comparit/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VergleichBoxComponent } from '../vergleich-box/vergleich-box.component';
import { TarifDokumenteComponent } from '../tarif-dokumente/tarif-dokumente.component';
import { VersichererInfoComponent } from '../versicherer-info/versicherer-info.component';
import { TarifHeaderComponent } from '../tarif-header/tarif-header.component';
import { TarifdetailsCtaComponent } from '../tarifdetails-cta/tarifdetails-cta.component';
import { TarifdetailsPageService } from './tarifdetails-page.service';

/**
 * `/tarifdetails/:vorgangId` — the chosen tariff in full: header, insurer, documents and the
 * Tarifdaten groups, with the Antrag as its call to action. Sparte-agnostic: everything it reads
 * comes through `TarifdetailsBaseService`.
 */
@Component({
  selector: 'ui-tarifdetails-page',
  templateUrl: './tarifdetails-page.component.html',
  styleUrl: './tarifdetails-page.component.scss',
  imports: [
    AsyncPipe,
    ApiAsyncPipe,
    ApiErrorComponent,
    StatusNoticeComponent,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    VergleichBoxComponent,
    TarifDokumenteComponent,
    VersichererInfoComponent,
    TarifHeaderComponent,
    TarifdetailsCtaComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TarifdetailsPageService],
})
export class TarifdetailsPageComponent {
  protected readonly td = inject(TarifdetailsPageService);
}
